import { animate, state, style, transition, trigger } from '@angular/animations';

export const SCROLLOPACITY = trigger('scrollOpacity', [
  state('open', style({ opacity: 0 })),
  state('closed', style({ opacity: 1 })),
  transition('open => closed', [animate('.5s .2s ease-in-out')]),
  transition('closed => open', [animate('.2s ease-in-out')])
]);
